var MapsLocation= function() {

	this.init = function() {

		this.mapsLocation();

	}

	this.mapsLocation = function() {

		$("[data-component='maps-location']").each(function(){

			var lat = $(this).find(".eventDetails").data('lat');
			var lng = $(this).find(".eventDetails").data('lng');

	 		map = new google.maps.Map($(this).find("#maps-location")[0], {
	          center: {lat:lat, lng: lng},
	          zoom: 13,	          
	        });	 

	        var marker = new google.maps.Marker({
    			position: {lat: lat,lng: lng},
    			map: map/*,
    			title: 'AQUI!'*/
  			});    


    
		});
	}
	
	return this.init();
}